module.exports = __webpack_public_path__ + "Icono_Toracica-Bco_126px.png";